export default {"src":"/_next/static/media/generic.ad8a9514.svg","height":512,"width":513};